import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const fetchPOForGRN = payload => AxiosClient.post('/get-grn-po', payload)
export {
    fetchPOForGRN
  }